module.exports = __webpack_public_path__ + "static/media/accruent.1c9542a3.png";